<div class="main-content">
  <router-outlet></router-outlet>
  <!-- This is where all page content loads -->
</div>
<!-- test -->